import React from "react"
import { Control, Controller } from "react-hook-form"
import Input from "../../Ui/Form/Input"
import { SidebarDivider } from "../../DashboardSales/Shared.styled"
import { InputVoyadoConfig, VoyadoConfig } from "lib/types/generated/graphql-types"
import { FieldErrors } from "react-hook-form/dist/types/errors"
import { WithAuth } from "../../Auth"
import { PermissionGroups } from "../../../routes/constants"
import FallbackInput from "../../Ui/Form/FallbackInput"

interface ExtendedInputVoyadoConfig extends InputVoyadoConfig {
  id: string
}

type Props = {
  control: Control<ExtendedInputVoyadoConfig>
  errors: FieldErrors<ExtendedInputVoyadoConfig>
  defaultValues?: VoyadoConfig
  showId?: boolean
}

const isValidHttpUrl = (string: string) => {
  try {
    const newUrl = new URL(string)
    return newUrl.protocol === "https:"
  } catch (err) {
    console.error(err)
    return false
  }
}

const VoyadoConfigInputs = ({ control, errors, showId, defaultValues }: Props) => {
  return (
    <>
      {showId && (
        <Controller
          name="id"
          render={({ field }) => (
            <Input
              {...field}
              type="text"
              label="Identifier *"
              description="For internal use in Brink"
              placeholder="Aa - Zz, 0 - 9, -_."
              errors={errors}
            />
          )}
          control={control}
          rules={{
            required: "This is a required field",
            pattern: {
              value: /^[A-Za-z0-9_.-]+$/,
              message: "Only characters Aa-Zz and 0-9 are allowed. No spaces"
            }
          }}
          defaultValue=""
        />
      )}
      <SidebarDivider />
      <WithAuth requiredGroups={PermissionGroups.providers.write}>
        <Controller
          name="apiKey"
          render={({ field }) => (
            <Input {...field} type="text" label="Voyado API-key *" errors={errors} />
          )}
          control={control}
          rules={{
            required: "This is a required field"
          }}
          defaultValue=""
        />
      </WithAuth>
      <WithAuth
        requiredGroups={PermissionGroups.providers.write}
        fallback={<FallbackInput label={"Base URL"} value={defaultValues?.baseUrl} />}
      >
        <Controller
          name="baseUrl"
          render={({ field }) => (
            <Input
              {...field}
              type="text"
              label="Voyado base URL *"
              description="Must be https:// format"
              errors={errors}
            />
          )}
          control={control}
          rules={{
            validate: {
              url: (value) => {
                if (!isValidHttpUrl(value)) return "Must be https:// format"
              }
            },
            required: "This is a required field"
          }}
          defaultValue={defaultValues?.baseUrl ?? ""}
        />
      </WithAuth>
    </>
  )
}

export default VoyadoConfigInputs
